/* eslint-disable */ // legacy file
import * as errors from "./errors/errors";
import Croppie from "croppie";

var updateImgDialogBackdrop = document.getElementById("updateImgDialogBackdrop"),
    updateImgDialog = document.getElementById("updateImgDialog"),
    imgInput = document.getElementById("imgInput"),
    imgUploadProgress = document.getElementById("imgUploadProgress"),
    imgUploadProgressValue = document.getElementById("imgUploadProgressValue"),
    newImg = document.getElementById("newImg"),
    updateImgDialogCancelButton = updateImgDialog.querySelector("button.cancel"),
    updateImgDialogUpdateButton = updateImgDialog.querySelector("button.done"),
    croppieArea = document.getElementById("croppieArea"),
    profileBorder = document.querySelector(".profileBorder"),
    profileBorderRect = profileBorder.querySelector("rect"),
    imgFile,
    dragRefCount = 0,
    MAX_LOGO_SIZE = 4194304, // 4MiB
    urlPath,
    paramName,
    croppie,
    DURATION = 100,
    MIN_WIDTH = 240,
    MIN_HEIGHT = 240,
    MAX_WIDTH = 720,
    MAX_HEIGHT = 480,
    MIN_RADIUS = 4,
    MAX_RADIUS = 120,
    start,
    elapsed = DURATION + Math.EPSILON,
    duration = DURATION,
    initialWidth,
    initialHeight,
    initialRadius,
    requestId;

function closeImgDialog() {
    updateImgDialogBackdrop.classList.add("hidden");
    imgFile = null;
    updateImgDialog.classList.remove("uploading", "uploaded", "loaded", "tooBig", "badFormat", "disableZoomer");
    updateImgDialogUpdateButton.disabled = true;
    setLogoUploadProgress(0);
    destroyCroppie();
}

function destroyCroppie() {
    if (croppie) {
        croppie.destroy();
        croppie = null;
    }
}

function resetImgInput() {
    imgInput.value = "";
    newImg.src = "";
}

function open(url, name) {
    urlPath = url;
    paramName = name;
    resetImgInput();
    updateImgDialogBackdrop.classList.remove("hidden");
}

function addEventListener(type, listener) {
    updateImgDialog.addEventListener(type, listener);
}

function getImgFile(ev) {
    ev.preventDefault();
    ev.stopPropagation();

    restrict();
    imgFile = ev.type === "drop" ? ev.dataTransfer.files[0] : ev.target.files[0];

    updateImgDialog.classList.remove("badFormat", "tooBig");

    if (imgFile.type !== "image/jpeg" && imgFile.type !== "image/png") {
        updateImgDialog.classList.add("badFormat");
        return;
    }

    if (imgFile.size > MAX_LOGO_SIZE) {
        updateImgDialog.classList.add("tooBig");
        return;
    }

    var reader = new FileReader();
    reader.addEventListener("load", function (event) {
        newImg.src = event.target.result;

        newImg.addEventListener("load", function checkSize() {
            newImg.removeEventListener("load", checkSize);
            var disableZoomer = newImg.width <= 240 || newImg.height <= 240;

            updateImgDialog.classList.add("loaded");
            updateImgDialog.classList.toggle("disableZoomer", disableZoomer);
            updateImgDialogUpdateButton.disabled = false;

            destroyCroppie();

            var newHeight,
                zoomRatio = 1;
            if (newImg.width < 240) {
                zoomRatio = 240 / newImg.width;
                newHeight = zoomRatio * newImg.height;

                if (newHeight < 240) {
                    zoomRatio = 240 / newHeight;
                }
            } else if (newImg.width > 720) {
                zoomRatio = 720 / newImg.width;
                newHeight = newImg.height / zoomRatio;

                if (newHeight > 294) {
                    zoomRatio = 294 / newImg.height;
                } else if (newHeight < 240) {
                    zoomRatio = 240 / newHeight;
                }
            } else {
                zoomRatio = newImg.width / 720;
                if (newImg.height < 240) {
                    zoomRatio = 240 / newImg.height;
                } else if (newImg.height > 294) {
                    zoomRatio = 294 / newImg.height;
                }
            }

            croppie = new Croppie(croppieArea, {
                viewport: {
                    width: 240,
                    height: 240,
                    type: "circle"
                },
                boundary: {
                    width: 720,
                    height: 294
                },
                customClass: "zpl-croppie",
                mouseWheelZoom: !disableZoomer
            });

            croppie.bind({
                url: event.target.result,
                zoom: zoomRatio
            });
        });
    });
    reader.readAsDataURL(imgFile);
}

document.addEventListener("dragover", function (ev) {
    ev.preventDefault();
    ev.stopPropagation();
});

document.addEventListener("drop", function (ev) {
    ev.preventDefault();
    ev.stopPropagation();
});

document.addEventListener("keydown", function (ev) {
    switch (ev.keyCode) {
        case Zeplin.KEY_CODE.ESC:
            ev.stopPropagation();
            closeImgDialog();
            break;
    }
});

updateImgDialog.addEventListener("dragenter", function (ev) {
    ev.preventDefault();
    ev.stopPropagation();

    dragRefCount++;
    updateImgDialog.classList.add("dragover");
    start = null;
    cancelAnimationFrame(requestId);
    requestId = requestAnimationFrame(expand);
});

updateImgDialog.addEventListener("dragleave", function (ev) {
    if (!--dragRefCount) {
        restrict();
    }
});

updateImgDialog.addEventListener("dragend", function (ev) {
    restrict();
});

updateImgDialog.addEventListener("drop", getImgFile);
imgInput.addEventListener("change", getImgFile);

updateImgDialog.addEventListener("click", function (ev) {
    ev.stopPropagation();
});

function createUploadLogoRequest(path, onSuccess, onError) {
    var xhr = new XMLHttpRequest();

    xhr.addEventListener("load", function () {
        var status = xhr.status,
            body = xhr.response;

        if (status < 100 || status > 599) {
            onError(new TypeError("Network request failed"));
            return;
        } else if (status > 399 && status < 600) {
            onError(errors.createError(status, body));
            return;
        }

        onSuccess(body);
    });

    xhr.addEventListener("error", function () {
        onError(new TypeError("Network request failed"));
    });

    xhr.open("PUT", Zeplin.urls.baseURL + path);
    xhr.setRequestHeader("Zeplin-Token", Zeplin.headers.get("Zeplin-Token"));

    xhr.responseType = "json";

    return xhr;
}

function setLogoUploadProgress(progress) {
    imgUploadProgress.value = progress;
    imgUploadProgress.textContent = progress + "%";
    imgUploadProgressValue.textContent = progress;
}

function uploadImg(path, imageFile) {
    var formData = new FormData();

    formData.append(paramName, imageFile);

    return new Promise(function (resolve, reject) {
        var xhr = createUploadLogoRequest(path, resolve, reject);

        function abort() {
            xhr.abort();
        }

        updateImgDialogCancelButton.addEventListener("click", abort);

        xhr.upload.addEventListener("progress", function onProgress(ev) {
            var progress = Math.round(ev.loaded / ev.total * 100);

            setLogoUploadProgress(progress);
        });

        xhr.upload.addEventListener("loadend", function () {
            updateImgDialogCancelButton.removeEventListener("click", abort);
        });

        xhr.send(formData);
    });
}

function changeImg(img) {
    setLogoUploadProgress(0);
    updateImgDialogUpdateButton.disabled = true;
    updateImgDialog.classList.add("uploading");

    uploadImg(urlPath, img).then(function (response) {
        updateImgDialog.classList.remove("uploading");
        updateImgDialog.classList.add("uploaded");

        updateImgDialog.dispatchEvent(new CustomEvent("upload", {
            detail: img
        }));

        setTimeout(function () {
            closeImgDialog();
        }, 1000);
    }).catch(function (error) {
        updateImgDialog.classList.remove("uploading", "loaded");
        resetImgInput();
        updateImgDialogUpdateButton.disabled = true;

        errors.handleError(error);
    });
}

function cropImg() {
    croppie.result({
        type: "blob",
        circle: false,
        size: "viewport"
    }).then(function (response) {
        changeImg(response);
    });
}

updateImgDialogBackdrop.addEventListener("click", function (ev) {
    ev.stopPropagation();
    closeImgDialog();
});

updateImgDialogCancelButton.addEventListener("click", function (ev) {
    ev.stopPropagation();
    closeImgDialog();
});

updateImgDialogUpdateButton.addEventListener("click", function (ev) {
    ev.stopPropagation();
    cropImg();
});

function expand(ts) {
    if (!start) {
        start = ts;
        initialWidth = profileBorderRect.width.baseVal.value;
        initialHeight = profileBorderRect.height.baseVal.value;
        initialRadius = profileBorderRect.rx.baseVal.value;

        if (elapsed && elapsed < duration) {
            duration = elapsed;
        } else {
            duration = DURATION;
        }

        profileBorder.style.transition = "top " + (duration / 2) + "ms linear";
    }

    elapsed = ts - start;
    var width,
        height,
        radius;

    if (updateImgDialog.classList.contains("dragover")) {
        width = Math.min(initialWidth + (MAX_WIDTH - initialWidth) / duration * elapsed, MAX_WIDTH);
        height = Math.min(initialHeight + (MAX_HEIGHT - initialHeight) / duration * elapsed, MAX_HEIGHT);
        radius = Math.max(initialRadius - (initialRadius - MIN_RADIUS) / duration * elapsed, MIN_RADIUS);
    } else {
        width = Math.max(initialWidth - (initialWidth - MIN_WIDTH) / duration * elapsed, MIN_WIDTH);
        height = Math.max(initialHeight - (initialHeight - MIN_HEIGHT) / duration * elapsed, MIN_HEIGHT);
        radius = Math.min(initialRadius + (MAX_RADIUS - initialRadius) / duration * elapsed, MAX_RADIUS);
    }

    profileBorder.width.baseVal.value = width + 6;
    profileBorderRect.width.baseVal.value = width;

    profileBorder.height.baseVal.value = height + 6;
    profileBorderRect.height.baseVal.value = height;

    profileBorderRect.rx.baseVal.value = radius;

    if (elapsed < duration) {
        requestId = requestAnimationFrame(expand);
    } else {
        start = null;
    }
}

function restrict() {
    dragRefCount = 0;
    start = null;
    cancelAnimationFrame(requestId);
    updateImgDialog.classList.remove("dragover");
    requestId = requestAnimationFrame(expand);
}

export {
    open,
    addEventListener
};
